/// <amd-module name="Search/Package/Flux/Sources/TelemetrySpy" />

import * as BaseActionsHub from "Search/Shared/Base/ActionsHub2";
import { ActionsHub } from "Search/Package/Flux/ActionsHub";
import { TelemetryWriter } from "Search/Package/Flux/Sources/TelemetryWriter";
import { PackageSearchRequest, PackageResult, PackageSearchResponseContent } from "Search/WebApi/Contracts/Search.Shared";
import { CustomerIntelligenceConstants } from "Search/Package/Constants";

/**
 * Writes telemetry events based on actions in package search page.
 */
export class TelemetrySpy {
    constructor(
        private telemetryWriter: TelemetryWriter,
        private actionsHub: ActionsHub) {
        this.registerActionsHubHandlers();
    }

    public dispose = (): void => {
        this.disposeActionsHubHandlers();
        this.telemetryWriter.dispose();
    }

    private registerActionsHubHandlers = (): void => {
        this.actionsHub.searchStarted.addListener(this.publishSearchStarted);
        this.actionsHub.pageInitializationStarted.addListener(this.publishPageInitializationStarted);
        this.actionsHub.resultsLoaded.addListener(this.publishResultsLoaded);
    }

    private disposeActionsHubHandlers = (): void => {
        this.actionsHub.searchStarted.removeListener(this.publishSearchStarted);
        this.actionsHub.pageInitializationStarted.removeListener(this.publishPageInitializationStarted);
        this.actionsHub.resultsLoaded.removeListener(this.publishResultsLoaded);
    }

    private publishPageInitializationStarted = (payload: BaseActionsHub.IPageInitializationStartedPayload<PackageSearchRequest>): void => {
        this.telemetryWriter.notifySearchStarted();
        this.telemetryWriter.publish(CustomerIntelligenceConstants.SearchStarted, {});

        const { launchPoint } = payload;
        if (launchPoint) {
            this.telemetryWriter.publish(CustomerIntelligenceConstants.LaunchPoint, { launchPoint });
        }
    }

    private publishSearchStarted = (payload: BaseActionsHub.ISearchStartedPayload<PackageSearchRequest>): void => {
        this.telemetryWriter.notifySearchStarted();
        this.telemetryWriter.publish(CustomerIntelligenceConstants.SearchStarted, {});
        if (payload.fetchMoreScenario) {
            this.telemetryWriter.publish(CustomerIntelligenceConstants.FetchMoreResultsStarted);
        }
    }

    private publishResultsLoaded = (payload: BaseActionsHub.IResultsLoadedPayload<PackageSearchRequest, PackageSearchResponseContent, PackageResult>): void => {
        this.telemetryWriter.publish(CustomerIntelligenceConstants.ResultsLoaded, {
            totalCount: payload.response.count,
            resultsShown: payload.response.results.length
        });
    }
}